<ng-container *ngIf="!loading">
    <div class="cookies-dialog-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="privacy-icon">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            <path d="m9 11 2 2 4-4"/>
        </svg>
    </div>
    <div class="floori-dialog-header">
        <span>{{ "cookies.header" | flTranslate }}</span>
    </div>
    <section floori-dialog-content class="cookies-dialog-content">
        <p>{{ "cookies.content" | flTranslate }}</p>
    </section>
    <div floori-dialog-actions class="cookies-dialog-actions">
        <button floori-button class="floori-button outline big reject-btn" [floori-dialog-close]="false">
            {{ "cookies.reject" | flTranslate }}
        </button>
        <button class="floori-button primary big accept-btn" [floori-dialog-close]="true">
            {{ "cookies.accept" | flTranslate }}
        </button>
    </div>
</ng-container>

